import { render, staticRenderFns } from "./questionConsultationRank.vue?vue&type=template&id=6570c33d&scoped=true"
import script from "./questionConsultationRank.vue?vue&type=script&lang=js"
export * from "./questionConsultationRank.vue?vue&type=script&lang=js"
import style0 from "./questionConsultationRank.vue?vue&type=style&index=0&id=6570c33d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570c33d",
  null
  
)

export default component.exports